module.exports = __webpack_public_path__ + "img/failed@2x.51ec85b2.png";